import {
    FETCH_TODO_REQUEST,
    FETCH_TODO_FAILURE,
    FETCH_TODO_SUCCESS,
    FETCH_LANGUAGES_FAIL,
    FETCH_LANGUAGES_REQUEST,
    FETCH_LANGUAGES_SUCCESS,
    FETCH_WORDS_FAIL,
    FETCH_WORDS_REQUEST,
    FETCH_WORDS_SUCCESS,
    ADD_LANGUAGES_REQUEST,
    EDIT_WORD_REQUEST,
    ADD_WORD_REQUEST,
    EDIT_WORD_SUCCESS
} from "./actionTypes";
import {
    FetchTodoRequest,
    FetchTodoSuccess,
    FetchTodoSuccessPayload,
    FetchTodoFailure,
    FetchTodoFailurePayload,

    FetchLanguageFail,
    FetchLanguageRequest,
    FetchLanguageSuccess,
    FetchLanguageSuccessPayload,
    FetchLanguageFailurePayload,
    AddLanguageRequest,

    FetchWordFail,
    FetchWordFailurePayload,
    FetchWordRequest,
    FetchWordSuccess,
    FetchWordSuccessPayload,
    EditWordRequest,
    AddWordRequest,
    EditWordSuccess,
    EditWordSuccessPayload,
} from "./types";

export const fetchTodoRequest = (object: any): FetchTodoRequest => ({
    type: FETCH_TODO_REQUEST,
    params: object.params // { title: 'abc' }
});

export const fetchTodoSuccess = (
    payload: FetchTodoSuccessPayload,
): FetchTodoSuccess => ({
    type: FETCH_TODO_SUCCESS,
    payload,
});

export const fetchTodoFailure = (
    payload: FetchTodoFailurePayload,
): FetchTodoFailure => ({
    type: FETCH_TODO_FAILURE,
    payload,
});

export const fetchLanguageRequest = (): FetchLanguageRequest =>({
    type: FETCH_LANGUAGES_REQUEST,
})
export const addLanguageRequest = (object: any): AddLanguageRequest =>({
    type: ADD_LANGUAGES_REQUEST,
    body: object.body
})

export const fetchLanguageSuccess = (
    payload: FetchLanguageSuccessPayload
): FetchLanguageSuccess =>({
    type: FETCH_LANGUAGES_SUCCESS,
    payload
})

export const fetchLanguageFail = (
    payload: FetchLanguageFailurePayload
): FetchLanguageFail =>({
    type: FETCH_LANGUAGES_FAIL,
    payload
})
export const fetchWordRequest = (object: any): FetchWordRequest =>({
    type: FETCH_WORDS_REQUEST,
    params: object.params // { tilte: 'abc', page: 1 }
})

export const fetchWordSuccess = (
    payload: FetchWordSuccessPayload
): FetchWordSuccess =>({
    type: FETCH_WORDS_SUCCESS,
    payload
})
export const editWordSuccess = (
    payload: EditWordSuccessPayload
): EditWordSuccess =>({
    type: EDIT_WORD_SUCCESS,
    payload
})
export const fetchWordFail = (
    payload: FetchWordFailurePayload
): FetchWordFail =>({
    type: FETCH_WORDS_FAIL,
    payload
})
export const editWordRequest = (object: any): EditWordRequest =>({
    type: EDIT_WORD_REQUEST,
    body: object
})
export const addWordRequest = (object: any):AddWordRequest =>({
    type: ADD_WORD_REQUEST,
    body: object
})